import React, { useEffect, useState, useRef } from "react";
import { Container, PopupContainer } from "./styled";
import { useLocation } from "react-router-dom";
import { Layout } from "../../containers";
import { calculatePlayerStats } from "../../lib/cabbStats";
import html2canvas from "html2canvas";

const PlayerCard = ({
  appData,
  isBoxScore,
  activePlayer,
  activePlayerTeam,
  setIsCardPopupActive,
}) => {
  const [activeProfile, setActiveProfile] = useState(null);
  const [activePhase, setActivePhase] = useState(null);
  const [activeSeason, setActiveSeason] = useState(
    process.env.REACT_APP_ACTIVE_SEASON
  );
  const [activeTeam, setActiveTeam] = useState(null);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [games, setGames] = useState(null);
  const location = useLocation();
  const captureRef = useRef(null);
  let link = location.pathname.replace("/playerCard/", "");
  let slug = link.split("/")[0];

  useEffect(() => {
    if (appData.teams !== null && appData.players !== null) {
      let filterTeams = appData?.teams?.filter((e) => e._id === slug);
      if (filterTeams.length > 0 && !isBoxScore) {
        setActiveProfile(filterTeams[0]);
      } else {
        let filterPlayers = appData?.players?.filter((e) => e._id === slug);
        setActiveProfile(filterPlayers[0]);
      }
    }
    if (isBoxScore) {
      if (activePlayerTeam[1] === "local")
        setActiveTeam(activePlayerTeam[0].local_team);
      else if (activePlayerTeam[1] === "visit")
        setActiveTeam(activePlayerTeam[0].visit_team);
      generateImageCanvas();
    }
  }, [appData, appData.teams, appData.players, slug, isBoxScore]);

  useEffect(() => {
    if (appData.players !== null) {
      let filterPlayers = appData?.players?.filter((e) => e._id === slug);
      fetchGamesBySeasonAndTeams(filterPlayers[0]?.teams_history);
    }
  }, [appData, appData.players, activeSeason, slug, activeProfile]);

  const fetchGamesBySeasonAndTeams = async (teams) => {
    try {
      const fetchPromises = teams
        .filter((team) => team.season === activeSeason) // Filtra equipos por temporada activa
        .map((team) =>
          fetch(
            `https://deportactico-vercel-serverless.vercel.app/api/gamesByTeam?season=${activeSeason}&teamId=${team.teamId}`
          ).then((response) => response.json())
        );

      const results = await Promise.all(fetchPromises);

      // Fusiona todos los arrays en un solo array
      const games = results.flat(); // 'flat' aplana los arrays en un solo nivel

      let gamesArr = [];

      let teamsHistory = activeProfile.teams_history
        .filter((item) => item.season === activeSeason)
        .map((team) => team.teamId);

      for (let index = 0; index < games.length; index++) {
        const currentGame = games[index];
        const isActivePhase =
          activePhase === null || currentGame.stage === activePhase;

        if (
          teamsHistory.includes(currentGame.local_team) &&
          currentGame.season === activeSeason &&
          isActivePhase
        ) {
          const idx = currentGame.local_stats.findIndex(
            (obj) => obj.player_id === slug
          );
          if (
            idx > -1 &&
            Number(currentGame.local_stats[idx].mins.replace(":", ".")) > 0
          ) {
            gamesArr.push({
              stat: currentGame.local_stats[idx],
              game: currentGame,
            });
          }
        } else if (
          teamsHistory.includes(currentGame.visit_team) &&
          currentGame.season === activeSeason &&
          isActivePhase
        ) {
          const idx = currentGame.visit_stats.findIndex(
            (obj) => obj.player_id === slug
          );
          if (
            idx > -1 &&
            Number(currentGame.visit_stats[idx].mins.replace(":", ".")) > 0
          ) {
            gamesArr.push({
              stat: currentGame.visit_stats[idx],
              game: currentGame,
            });
          }
        }
      }

      // --- DEDUPLICACIÓN POR ID DE PARTIDO ---
      const seenGameIds = new Set();
      const dedupedStats = [];
      const dedupedGames = [];

      for (const { stat, game } of gamesArr) {
        const gameId = game._id.toString();
        if (!seenGameIds.has(gameId)) {
          seenGameIds.add(gameId);
          dedupedStats.push(stat);
          dedupedGames.push(game);
        }
      }

      setGames(dedupedGames);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const loadimages = () => {
    const images = document.querySelectorAll("#card-container img");
    const promises = Array.from(images).map((img) => {
      return new Promise((resolve) => {
        img.addEventListener("load", resolve);
      });
    });
    Promise.all(promises).then(() => {
      setImagesLoaded(true);
    });
  };

  const generateImageCanvas = async () => {
    let popup = document
      .getElementById("card-container")
      .classList.add("to-print");
    await loadimages();
    await new Promise((resolve) => setTimeout(resolve, 500));

    const canvas = await html2canvas(captureRef.current, {
      backgroundColor: null,
    });
    const dataUrl = canvas.toDataURL("image/png");
    let linkUrl = isBoxScore
      ? `${activePlayer.player_name} - ${
          appData.teams.filter((e) => {
            return e._id === activePlayerTeam[0].local_team;
          })[0].name
        } vs ${
          appData.teams.filter((e) => {
            return e._id === activePlayerTeam[0].visit_team;
          })[0].name
        } - Temporada ${activePlayerTeam[0].season}.png`
      : `${activeProfile.player_name} ${
          activeProfile.player_lastname
        } - Temporada ${activeSeason} - ${
          activePhase === null ? "Temporada completa" : activePhase
        }.png`;
    var link = document.createElement("a");
    link.download = linkUrl;
    link.href = dataUrl;
    link.click();
    document.getElementById("card-container").classList.remove("to-print");
    if (isBoxScore) setIsCardPopupActive();
  };

  return (
    <>
      {!isBoxScore ? (
        <Layout isPositionUnset={true}>
          <Container>
            <div className="card-page-header">
              <div className="option-content">
                <label>Temporada</label>
                <select
                  id="season-select"
                  onChange={(e) => {
                    setActiveSeason(e.target.value);
                  }}
                >
                  <option hidden>Selecciona temporada</option>
                  <option>2023/2024</option>
                  <option>2024/2025</option>
                </select>
              </div>
              <div className="option-content">
                <label>Fase</label>
                <select
                  id="season-select"
                  onChange={(e) => {
                    e.target.value !== "Temporada completa"
                      ? setActivePhase(e.target.value)
                      : setActivePhase(null);
                  }}
                >
                  <option hidden defaultValue>
                    Selecciona Fase
                  </option>
                  <option>Temporada completa</option>
                  <option>Fase regular</option>
                  <option>Play in</option>
                  <option>Reclasificación</option>
                  <option>Playoff</option>
                  <option>Permanencia</option>
                </select>
              </div>
              <button className="btn-primary" onClick={generateImageCanvas}>
                Descargar
              </button>
            </div>
            {activeProfile !== null ? (
              <div
                id="card-container"
                className="card-container"
                ref={captureRef}
              >
                <div className="top-container">
                  <div className="header">
                    <div className="logo-container">
                      <img
                        className="navbarLogo"
                        src="/assets/Logo.png"
                        alt="deportactico logo"
                      />
                      <h1>Deportactico</h1>
                    </div>
                    <div className="team-logo-container">
                      {activeProfile?.teams_history
                        .filter((item) => item.season === activeSeason)
                        .map((team, index) => (
                          <img
                            src={`/assets/teams-logos/${
                              appData.teams?.filter((e) => {
                                return !isBoxScore && e._id === team.teamId;
                              })[0]?.name
                            }.png`}
                            alt="team logo"
                            onLoad={() => {
                              setImagesLoaded(true);
                            }}
                            style={index >= 1 ? { marginLeft: "-30px" } : {}}
                          />
                        ))}
                    </div>
                  </div>
                  <img
                    className="placeholder-img"
                    src="/assets/player-card-placeholder.png"
                  />
                </div>
                <div className="middle-container">
                  <div className="content-container">
                    <h1>{activeProfile.player_number}</h1>
                    <hr />
                    <div>
                      <h3>
                        {activeProfile.player_name}{" "}
                        {activeProfile.player_lastname}{" "}
                      </h3>
                      <div className="sub-title">
                        <p>
                          {
                            appData.teams.filter((e) => {
                              return e._id === activeProfile.active_team;
                            })[0]?.name
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bottom-container">
                  <div className="stat-container">
                    <div className="stat">
                      <h3>
                        {calculatePlayerStats(
                          games?.filter(
                            (game) =>
                              game.season === activeSeason &&
                              (activePhase === null ||
                                game.stage === activePhase)
                          ),
                          activeProfile._id,
                          "MINSP"
                        )}
                      </h3>
                      <p>MINUTOS</p>
                    </div>
                    <div className="stat">
                      <h3>
                        {calculatePlayerStats(
                          games?.filter(
                            (game) =>
                              game.season === activeSeason &&
                              (activePhase === null ||
                                game.stage === activePhase)
                          ),
                          activeProfile._id,
                          "PTS"
                        )}
                      </h3>
                      <p>PUNTOS</p>
                    </div>
                  </div>
                  <div className="stat-container">
                    <div className="stat">
                      <h3>
                        {calculatePlayerStats(
                          games?.filter(
                            (game) =>
                              game.season === activeSeason &&
                              (activePhase === null ||
                                game.stage === activePhase)
                          ),
                          activeProfile?._id,
                          "FGP"
                        )}
                      </h3>
                      <p>FG%</p>
                    </div>
                    <div className="stat">
                      <h3>
                        {calculatePlayerStats(
                          games?.filter(
                            (game) =>
                              game.season === activeSeason &&
                              (activePhase === null ||
                                game.stage === activePhase)
                          ),
                          activeProfile._id,
                          "REB"
                        )}
                      </h3>
                      <p>REBOTES</p>
                    </div>
                  </div>
                  <div className="stat-container">
                    <div className="stat">
                      <h3>
                        {calculatePlayerStats(
                          games?.filter(
                            (game) =>
                              (game.local_team ===
                                activeProfile.teams_history.find(
                                  (item) => item.season === activeSeason
                                ).teamId ||
                                game.visit_team ===
                                  activeProfile.teams_history.find(
                                    (item) => item.season === activeSeason
                                  ).teamId) &&
                              game.season === activeSeason &&
                              (activePhase === null ||
                                game.stage === activePhase)
                          ),
                          activeProfile._id,
                          "ASS"
                        )}
                      </h3>
                      <p>ASISTENCIAS</p>
                    </div>
                    <div className="stat">
                      <h3>
                        {calculatePlayerStats(
                          games?.filter(
                            (game) =>
                              (game.local_team ===
                                activeProfile.teams_history.find(
                                  (item) => item.season === activeSeason
                                ).teamId ||
                                game.visit_team ===
                                  activeProfile.teams_history.find(
                                    (item) => item.season === activeSeason
                                  ).teamId) &&
                              game.season === activeSeason &&
                              (activePhase === null ||
                                game.stage === activePhase)
                          ),
                          activeProfile._id,
                          "STL"
                        )}
                      </h3>
                      <p>ROBOS</p>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </Container>
        </Layout>
      ) : (
        <PopupContainer>
          <div id="card-container" className="card-container" ref={captureRef}>
            <div className="top-container">
              <div className="header">
                <div className="logo-container">
                  <img
                    className="navbarLogo"
                    src="/assets/Logo.png"
                    alt="deportactico logo"
                  />
                  <h1>Deportactico</h1>
                </div>
                <div className="team-logo-container">
                  {activeTeam !== null ? (
                    <img
                      src={`/assets/teams-logos/${
                        appData.teams.filter((e) => {
                          return e._id === activeTeam;
                        })[0].name
                      }.png`}
                      alt="team logo"
                      onLoad={() => {
                        setImagesLoaded(true);
                      }}
                    />
                  ) : null}
                </div>
              </div>
              <img
                className="placeholder-img"
                src="/assets/player-card-placeholder.png"
              />
            </div>
            <div className="middle-container">
              <div className="content-container">
                <h1>
                  {
                    appData?.players?.filter(
                      (playerdb) => playerdb._id === activePlayer.player_id
                    )[0]?.player_number
                  }
                </h1>
                <hr />
                <div>
                  <h3>{activePlayer.player_name}</h3>
                  <div className="sub-title">
                    {activeTeam !== null ? (
                      <p>
                        {
                          appData.teams.filter(
                            (e) => isBoxScore && e._id === activeTeam
                          )[0].name
                        }
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="bottom-container">
              <div className="stat-container">
                <div className="stat">
                  <h3>{activePlayer.mins}</h3>
                  <p>MINUTOS</p>
                </div>
                <div className="stat">
                  <h3>{activePlayer.pts}</h3>
                  <p>PUNTOS</p>
                </div>
              </div>
              <div className="stat-container">
                <div className="stat">
                  <h3>{(activePlayer["2pPcj"] + activePlayer["3pPcj"]) / 2}</h3>
                  <p>FG%</p>
                </div>
                <div className="stat">
                  <h3>{activePlayer.rebTot}</h3>
                  <p>REBOTES</p>
                </div>
              </div>
              <div className="stat-container">
                <div className="stat">
                  <h3>{activePlayer.ass}</h3>
                  <p>ASISTENCIAS</p>
                </div>
                <div className="stat">
                  <h3>{activePlayer.rec}</h3>
                  <p>ROBOS</p>
                </div>
              </div>
            </div>
          </div>
        </PopupContainer>
      )}
    </>
  );
};

export default PlayerCard;
